import getSeconds from "date-fns/getSeconds";
import subSeconds from "date-fns/subSeconds";
import { useRef } from "react";

export const useDateCurrent = (roundToMinute: boolean = false) => {
  const dateRef = useRef(new Date());

  if (roundToMinute)
    return {
      dateCurrent: subSeconds(dateRef.current, getSeconds(dateRef.current)),
    };

  return { dateCurrent: dateRef.current };
};
